// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"quoteFileRender_tooltip__24vzf","fileName":"quoteFileRender_fileName__29nQO","buttonLink":"quoteFileRender_buttonLink__jBMvT","quotes":"quoteFileRender_quotes__3FlAm"};